class BulkDataController extends AbstractController
	@register()
	@inject '$filter',
		'$stateParams'
		'BulkDataRepository'
		'ConfigurationService'
		'priceRegions'
		'ticketEvents'
		'ticketEventSessions'
		'ticketTypes'
		'ToastService'
		'DateService'
		'snakeCaseToCamelCase'
		'ShopRepository'
		'user'

	initialize: ->
		@mainCrud.showFormActionButtons = false
		@bulkDataOptions = {}
		@shops = []
		@importFile = null
		@mainCrud.entityTitle = null
		@shouldFilterShops = @$stateParams.id == 'products'

		@deleteButtonText = 'wbo.bulk.data.' + @$stateParams.id + '.delete.all';
		@deleteButtonConfirmationText = 'wbo.bulk.data.' + @$stateParams.id + '.delete.all.question';

		if @$stateParams.id
			@mainCrud.entityTitle = 'general.' + @$stateParams.id

			if @$stateParams.id == 'tickets'
				@importEnabled = false
				@exportEnabled = @ConfigurationService.isEnabled 'Shared.Setting.Ticket.Enabled'
				@deleteEnabled = false

				@prepareTicketFilters()
			else if @$stateParams.id == 'customer_prices'
				enabled = @ConfigurationService.isEnabled 'Shared.Setting.CustomerPrices.Enabled'
				@importEnabled = enabled
				@exportEnabled = enabled
				@deleteEnabled = enabled
			else
				@importEnabled = @isBulkActionEnabled('Import', @$stateParams.id)
				@exportEnabled = @isBulkActionEnabled('Export', @$stateParams.id)
				@deleteEnabled = @isBulkActionEnabled('Delete', @$stateParams.id)

			if @importEnabled
				@loadRunningImports()

	isBulkActionEnabled: (action, entity) ->
		configurationKey = 'Backoffice.ImportAndExport.' + @snakeCaseToCamelCase(entity, false) + action + '.Enabled'

		return @ConfigurationService.isEnabled configurationKey

	loadRunningImports: ->
		@BulkDataRepository
			.findById(@$stateParams.id)
			.then (response) =>
				@runningImports = response.data

	sendImportRequest: ->
		@mainCrud.saving = true

		@bulkDataOptions.shop_ids = _.pluck @shops, 'id'

		@BulkDataRepository
			.saveWithAttachment(@$stateParams.id, {filters: @bulkDataOptions, file: @importFile})
			.then =>
				@ToastService.add(
					@$filter('translate')('alert.import.task.scheduled').toString(),
					@$filter('translate')('general.import'),
					@mainCrud.entityTitle,
					'success'
				)
				do @loadRunningImports
			.catch (response) =>
				@handleErrors response, @mainCrud.entityTitle
			.finally =>
				@mainCrud.saving = false
				@mainCrud.parent_form.$setPristine()

	sendDeleteRequest: ->
		@mainCrud.saving = true

		@BulkDataRepository
			.delete(@$stateParams.id)
			.then =>
				@ToastService.add(
					@$filter('translate')('alert.delete.task.scheduled').toString(),
					@$filter('translate')('general.delete'),
					@mainCrud.entityTitle
					'success'
				)
			.catch (response) =>
				@handleErrors response, @mainCrud.entityTitle
			.finally =>
				@mainCrud.saving = false

	prepareTicketFilters: ->
		@bulkDataOptions.event_id = @$stateParams.eventId
		@bulkDataOptions.session_id = @$stateParams.sessionId
		@bulkDataOptions.ticket_type_id = @$stateParams.ticketTypeId

		for session in @ticketEventSessions
			session.name = if session.name then session.name + ': ' else ''
			session.name += @DateService.format(session.start_date)

			if session.end_date
				session.name += ' - ' + @DateService.format(session.end_date)

	findShops: (searchString) ->
		query = @ShopRepository.createQuery()
		query.criteria 'name', 'LIKE', searchString

		if @user != null
			query.criteria 'id', 'IN', @user.shops.join()

		return @ShopRepository.findByQuery query
